import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitlementsEffects } from './entitlements.effects';
import { ENTITLEMENTS_FEATURE_KEY, authReducer } from './entitlements.reducer';

@NgModule({
    imports: [StoreModule.forFeature(ENTITLEMENTS_FEATURE_KEY, authReducer), EffectsModule.forFeature([EntitlementsEffects])]
})
export class EntitlementsStoreModule {}
